import { create } from 'zustand'

type TourProgressState = {
  currentStep: number
  totalSteps: number
  interactiveSteps: Set<number> // steps that require manual action
  completedSteps: Set<number> // steps the user has completed
  setCurrentStep: (step: number) => void
  setTotalSteps: (total: number) => void
  setInteractiveSteps: (steps: number[]) => void
  markStepCompleted: (step: number) => void
  resetTourProgress: () => void
  isStepCompleted: (step: number) => boolean
}

export const useTourProgressStore = create<TourProgressState>((set, get) => ({
  currentStep: 0,
  totalSteps: 0,
  interactiveSteps: new Set(),
  completedSteps: new Set(),

  setCurrentStep: (step) => set({ currentStep: step }),
  setTotalSteps: (total) => set({ totalSteps: total }),
  setInteractiveSteps: (steps) => set({ interactiveSteps: new Set(steps) }),

  markStepCompleted: (step) =>
    set((state) => ({
      completedSteps: new Set(state.completedSteps).add(step),
      currentStep: step + 1,
    })),

  isStepCompleted: (step) => {
    const { interactiveSteps, completedSteps } = get()
    return !interactiveSteps.has(step) || completedSteps.has(step)
  },

  resetTourProgress: () =>
    set({
      currentStep: 0,
      totalSteps: 0,
      interactiveSteps: new Set(),
      completedSteps: new Set(),
    }),
}))
